import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './sass/main.scss';
import VueI18n from 'vue-i18n';
import { messages, defaultLocale } from '@/i18n';
import permissionDirective from '@/directives/permission';
import { EventBus } from './eventBus';
import './utils/cacheDebug'; // Initialize cache debugging utilities

Vue.config.productionTip = false;
const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
});

// Mount the app
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
  data: {
    isLogined: false,
  },
}).$mount('#app');

// Re-export EventBus for backward compatibility
export { EventBus };

Vue.directive('permission', permissionDirective);
